import { render } from "./ProductPreviews.vue?vue&type=template&id=0c6736f7&scoped=true"
import script from "./ProductPreviews.vue?vue&type=script&lang=js"
export * from "./ProductPreviews.vue?vue&type=script&lang=js"

import "./ProductPreviews.vue?vue&type=style&index=0&id=0c6736f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6736f7"]])

export default __exports__